import { render } from "./interactionsOnLine.vue?vue&type=template&id=56b47bb4"
import script from "./interactionsOnLine.vue?vue&type=script&lang=js"
export * from "./interactionsOnLine.vue?vue&type=script&lang=js"

import "./interactionsOnLine.vue?vue&type=style&index=0&id=56b47bb4&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__